import { PlanFeature, PlanFeatureModel } from '@um/uptime-monitoring-shared';

export const getFeatureQuota = (feature: PlanFeature, features: { [key: string]: PlanFeatureModel }): number | null => {
  if (features && features[feature]) {
    return features[feature].quota;
  }

  return null;
};
